import type { Phase } from '@platform/contracts';

// Defines the default duration for each game phase in milliseconds.
// This is used as a fallback if the server does not provide timing information.
export const PHASE_CONFIG: Record<Phase, { defaultDuration: number }> = {
  WAITING: { defaultDuration: 5000 },
  BET_LOCK: { defaultDuration: 2000 },
  TAKEOFF: { defaultDuration: 1000 },
  FLYING: { defaultDuration: 0 }, // Indeterminate duration
  FLEW_AWAY: { defaultDuration: 3000 },
  REVEAL: { defaultDuration: 2000 },
  CRASHED: { defaultDuration: 2000 },
  UNKNOWN: { defaultDuration: 0 }, // Unknown phase, no duration
};
